import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LegalDocument } from '../components/LegalDocument';
import { termsOfUse } from '../lib/legal/termsOfUse';

export const Terms = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Braces are load-bearing: a concise arrow would hand scrollTo's return value
  // to React as the effect cleanup, and React calls anything that is not
  // undefined.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Opened from a pasted link or an email there is nothing to go back to, so
  // the button goes home instead of leaving the app.
  const goBack = () => (location.key === 'default' ? navigate('/') : navigate(-1));

  return (
    <div className="page legal-page" data-testid="terms-page">
      <header className="legal-back-row">
        <button
          className="back-btn"
          onClick={goBack}
          aria-label="Go back"
          data-testid="terms-back"
        >
          <ArrowLeft />
        </button>
      </header>

      <LegalDocument doc={termsOfUse} testId="terms-document" />
    </div>
  );
};
